import React, { Component } from 'react'
import Asidebar from '../components/aside/asidebar';
class Sidebar extends Component {
    render() {
        return (
            <Asidebar></Asidebar>
        )
    }
}

export default Sidebar
